import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import { useField } from 'formik';
import { Text } from '../Text/Text.js';
import { TextField } from '../TextField/TextField.js';

function PasswordStrength({
  value
}) {
  if (!value) return null;
  if (value.length <= 6) {
    return jsx(Text, {
      fontWeight: "semibold",
      className: "text-red",
      children: "Weak"
    });
  } else if (value.length > 6 && value.length <= 8) {
    return jsx(Text, {
      fontWeight: "semibold",
      className: "text-yellow",
      children: "Fair"
    });
  }
  return jsx(Text, {
    fontWeight: "semibold",
    className: "text-green",
    children: "Strong"
  });
}
const PasswordField = /*#__PURE__*/React.forwardRef(function PasswordField(props, ref) {
  const [{
    value
  }] = useField({
    name: props.name
  });
  return jsx(TextField, {
    ref: ref,
    type: "password",
    ...props,
    RightElement: jsx(PasswordStrength, {
      value: value
    })
  });
});

export { PasswordField };
